import React, { useEffect, useState } from 'react'
import { login } from 'api/login'
import swal from 'sweetalert2'
import { Formik } from 'formik'
import { useAuthentication } from 'hooks/useAuthentication'
import { useHistory } from 'react-router-dom'
import Input from 'components/Input/Input'
import { Button, Spinner } from 'reactstrap'

// @constants
import { RUTAS } from 'constants/constants'

import {
  decrypt,
  getUserEncryptedLocalStorage,
  removeUserEncryptedLocalStorage,
  setUserEncryptedLocalStorage,
} from 'utils/cryptographic'

export default function Login() {
  const [userEncrypted] = useState(() => {
    const user = getUserEncryptedLocalStorage()
    if (user) {
      const [username, password] = user
      return {
        username: decrypt(username),
        password: decrypt(password),
      }
    }
    return null
  })
  const [remember, setRemember] = useState(() => Boolean(userEncrypted))
  const { isAuth, setIsAuth } = useAuthentication()
  const history = useHistory()

  useEffect(() => {
    if (isAuth) {
      history.push(RUTAS.INICIO)
    }
  }, [history, isAuth])

  const onLogin = async (values, actions) => {
    const { username, password } = values
    await login(values)
      .then(() => {
        if (remember) {
          setUserEncryptedLocalStorage(username, password)
        } else {
          removeUserEncryptedLocalStorage()
        }
        setIsAuth()
      })
      .catch(() => {
        swal.fire({
          title: 'Oops!',
          text:
            'Las credenciales provistas no son correctas, verifique su usuario y/o contraseña',
          type: 'error',
        })
      })
      .finally(() => actions.setSubmitting(false))
  }

  return (
    <div className='bg-gradient-primary'>
      <div
        className='container '
        style={{ height: '100vh', display: 'grid', alignItems: 'center' }}
      >
        <div className='row justify-content-center'>
          <div
            className='col-xl-10 col-lg-12 col-md-9'
            style={{ marginBottom: '5em' }}
          >
            <div
              className='card o-hidden border-0 shadow-lg my-5'
              style={{ height: '100%' }}
            >
              <div className='card-body p-0'>
                <div className='row' style={{ height: '100%' }}>
                  <div className='col-lg-6 d-none d-lg-block bg-login-image'></div>
                  <div className='col-lg-6'>
                    <div className='p-5'>
                      <div className='text-center'>
                        <h1 className='h4 text-gray-900 mb-4'>Bienvenido!</h1>
                      </div>
                      <Formik
                        enableReinitialize
                        initialValues={
                          userEncrypted || {
                            username: '',
                            password: '',
                          }
                        }
                        onSubmit={onLogin}
                        render={({
                          handleChange,
                          handleSubmit,
                          values,
                          isSubmitting,
                        }) => (
                          <form className='user' onSubmit={handleSubmit}>
                            <Input
                              tipo='text'
                              mensajeFondo='Ingresa tu usuario'
                              name='username'
                              onChange={handleChange}
                              value={values.username}
                            />

                            <Input
                              tipo='password'
                              mensajeFondo='**********'
                              name='password'
                              onChange={handleChange}
                              value={values.password}
                            />

                            <div className='form-group'>
                              <div className='custom-control custom-checkbox small'>
                                <input
                                  type='checkbox'
                                  className='custom-control-input'
                                  id='remember'
                                  checked={remember}
                                  onChange={() => setRemember((s) => !s)}
                                />
                                <label
                                  className='custom-control-label'
                                  htmlFor='remember'
                                >
                                  Recuérdeme
                                </label>
                              </div>
                            </div>

                            <Button
                              className='btn-block'
                              type='submit'
                              color='primary'
                            >
                              {isSubmitting ? (
                                <Spinner size='sm' />
                              ) : (
                                'Iniciar sesión'
                              )}
                            </Button>
                          </form>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
